import apiUseCases from "@src/cloud-connect/api";
import { PostCreateDashboardTilesPayloadBuilder } from "./post-create-dashboard-tiles-payload-builder";

export const postCreateDashboardTiles = async (
  source_id,
  namespace,
  dashboardDataTiles,
) => {
  const payload = new PostCreateDashboardTilesPayloadBuilder(
    source_id,
    namespace,
    dashboardDataTiles,
  ).build();

  const data = await apiUseCases.createDashboard(payload);
  return data;
};
